// extracted by mini-css-extract-plugin
export default {"menu-container":"Menu_menu-container__lPHww"};